import React from 'react';
import {NavLink} from 'react-router-dom';
import {useSelector} from 'react-redux';

import NotificationIcon from './NotificationIcon';
import { Toast } from '../../ui/Toast/Toast';

const Navbar = () => {
    const userProfileData = useSelector((state) => state.UserReducer.userProfileData);

    let navElements = userProfileData.role === "CO" ?
        [
            {title: 'Affaires', to: 'deals'},
            {title: 'Temps', to: 'productions'},
            {title: 'Frais', to: 'expenses'},
            {title: 'Références', to: 'references'}
        ] :
        [
            {title: 'Affaires', to: 'deals'},
            {title: 'Facturation', to: 'invoices'},
            {title: 'Temps', to: 'productions'},
            {title: 'Frais', to: 'expenses'},
            {title: 'Références', to: 'references'}
        ]

    return (
        <>
            <Toast/>
            <nav
                className="fixed z-[20] flex items-center justify-between max-w-[1600px] w-full h-14 p-2 px-10 bg-white"
                style={{boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)'}}
            >
                <div className="flex-1" /> {/* Espace vide à gauche */}
                <ul className="flex items-center justify-center flex-1 gap-x-14">
                    {
                        navElements.map((item, index) => {
                            return (
                                <li key={index}>
                                    <NavLink to={`/${item.to}`} className={(link) => {
                                        return (
                                            `${link.isActive ? 'text-gradient' : 'text-[#212121] hover:underline hover:underline-offset-4'}`
                                        );
                                    }}>
                                        {item.title}
                                    </NavLink>
                                </li>
                            );
                        })
                    }
                </ul>
                <div className="flex flex-row items-center justify-end flex-1 gap-x-7">
                    <NotificationIcon userData={userProfileData}/>
                </div>
            </nav>
        </>
    );
};

export default Navbar;
